// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"b6237a3f","453":"64aababc","732":"23b9c75c"}[chunkId] + ".chunk.js";
};